
import AddressBlock from './AddressBlock';
import PaymentBlock from './PaymentBlock';
import ShippingBlock from './ShippingBlock';
import TotalsBlock from './TotalsBlock';
import ErrorBoundary from '../../utils/ErrorBoundary'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useEffect,useState } from 'react';
import './Checkout.scss'
import CloseIcon from '@mui/icons-material/Close';
import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

function CheckoutModal (props){
    const [name, setName] = useState('React');
    const [customerPO, setCustomerPO] = useState("");
    const [orderTotal, setOrderTotal] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState();
    const [shippingMethod, setShippingMethod] = useState (null);
    const [shipping, setShipping] = useState(0);



    const buttonStyles = {
        position: "absolute",
        top: "4px",
        right: "4px",
        border: "0",
        width: "40px",
        height: "30px",
        background: "none", 
        backgroundColor: "white"
    };



        return (
            
            <Modal className = "flex-col center" id="checkout"
                isOpen
                size='xl'>
                <Button onClick={props.onRequestClose} style={buttonStyles}><CloseIcon/></Button>
                <ModalHeader className="header">
                    Checkout                    
                </ModalHeader>
                <ModalBody className=''>
                     <div className='lil-box'>
                    <div className="row ch-1 ">
                        <AddressBlock token = {props.token}  />
                    </div>

                    <div className=' ch-2 '>
                        <ShippingBlock token = {props.token} 
                                        shippingMethod={shippingMethod} 
                                        setShippingMethod={setShippingMethod} 
                                        customerPO = {customerPO} 
                                        setCustomerPO = {setCustomerPO}
                                        paymentMethod = {paymentMethod}
                                        setPaymentMethod = {setPaymentMethod}/>
                    </div>

                     </div>           
                    <div className="row ">
                        <ErrorBoundary>
                            <PaymentBlock   token = {props.token} 
                                            onRequestClose={props.onRequestClose} 
                                            customerPO = {customerPO}
                                            orderTotal = {orderTotal}
                                            setOrderTotal = {setOrderTotal}
                                            paymentMethod = {paymentMethod}
                                            setPaymentMethod = {setPaymentMethod}
                                            cartCount = {props.cartCount}
                                            setCartCount = {props.setCartCount}
                                            shipping = {shipping}/>
                        </ErrorBoundary>
                        <TotalsBlock token = {props.token}
                                     orderTotal = {orderTotal}
                                     setOrderTotal = {setOrderTotal}
                                     shipping = {shipping}
                                     setShipping = {setShipping} 


                                     />
                    </div>
                </ModalBody>
            </Modal>
        );
    }

export default CheckoutModal;